import { createReducer } from "@utils/storeUtils";
export const initialState = {
    uploaded: null
};
const uploadStatus = (state, action) => {
    const { jobId, message } = action.payload;
    return {
        jobId,
        message,
        uploaded: action.type === "FILES_UPLOAD_SUCCESS"
    };
};
const uploadEnd = (state, action) => {
    return initialState;
};
const actionReducerMap = {
    ["FILES_UPLOAD_FAIL"]: uploadStatus,
    ["FILES_UPLOAD_SUCCESS"]: uploadStatus,
    ["CLEAR_FILES_UPLOAD_STATUS"]: uploadEnd
};
export default createReducer(initialState, actionReducerMap);
